import { UserService } from './../../shared/services/user.service';
import { Component, OnInit } from '@angular/core';
import { InstitutionsService } from '../../shared/services/institutions.service';
import { Institution } from '../../shared/model/institution';
import { Router, ActivatedRoute } from '@angular/router';
import { SaveService } from '../../shared/services/save.service';
import { IFavorite } from '../../shared/model/user';

@Component({
  selector: 'app-institution-list',
  templateUrl: './institution-list.component.html',
  styleUrls: ['./institution-list.component.css']
})
export class InstitutionListComponent implements OnInit {

  type: string;
  favoriteOn = false;
  allInstitutions: Institution[];
  filteredInstitutions: Institution[];
  favoriteInstitutions: Institution[];
  favoriteClick = false;
  searchField: string = null;

  constructor(private institutionsService: InstitutionsService,
    private router: Router, private saveService: SaveService,
    private route: ActivatedRoute, private userService: UserService) { }

  ngOnInit() {

    this.route.queryParams
      .subscribe(params => {
        this.type = params['type'];
      });

    this.institutionsService.findAllInstitutions()
      .subscribe(
      institution => {
        this.allInstitutions = this.filteredInstitutions = institution;
        if (this.type === "favorite") {
          if (this.saveService.getUser()) {
            this.myInstitution()
          }
        }
      }
      );
    this.saveService.setTitle("Gestion des institutions");
  }

  selectInstitution(institution: Institution) {
    if (!this.isUserAdmin()) {
      if (this.saveService.isUserFavorite(institution.$key)) {
        this.removeFromFavorite(institution);
      } else {
        this.addToFavorite(institution);
      }
    } else if (this.favoriteClick) {
      this.favoriteClick = false;
    } else {
      this.saveService.setInstitution(institution);
      this.router.navigate(['institution-update']);
    }
  }

  search(search: string) {
    if (this.favoriteOn) {
      this.filteredInstitutions = this.favoriteInstitutions
        .filter(Institution => (Institution.institutionName.toLowerCase()).includes(search.toLowerCase()));
    } else {
      this.filteredInstitutions = this.allInstitutions
        .filter(Institution => (Institution.institutionName.toLowerCase()).includes(search.toLowerCase()));
    }
  }

  create() {
    this.saveService.setTitle("Ajouter une institution");
    this.router.navigate(['institution-create']);
  }

  myInstitution() {
    this.favoriteOn = true;
    this.searchField = null;
    const favorite: string[] = this.saveService.getUserFavorite();
    this.favoriteInstitutions = [];
    this.allInstitutions.map(institution => {
      if (favorite.indexOf(institution.$key) > -1) {
        this.favoriteInstitutions.push(institution);
      }
    })
    this.filteredInstitutions = this.favoriteInstitutions;
  }

  clear() {
    this.favoriteOn = false;
    this.filteredInstitutions = this.allInstitutions;
    this.searchField = null;
  }

  addToFavorite(institution: Institution) {
    this.favoriteClick = true;
    this.saveService.addUserFavorite(institution.$key);
    const user = this.saveService.getUser();
    this.userService.saveUser(user.$key, user);
    this.router.navigate(['institution-list'])
  }

  removeFromFavorite(institution: Institution) {
    this.favoriteClick = true;
    this.saveService.removeUserFavorite(institution.$key);
    const user = this.saveService.getUser();
    this.userService.saveUser(user.$key, user);
    this.router.navigate(['institution-list'])
  }

  isFavorite(institution) {
    return this.saveService.isUserFavorite(institution.$key);
  }

  isUserAdmin() {
    return this.saveService.getUserType() === 'ADMIN';
  }
}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/institutions/institution-list/institution-list.component.ts